export const ItemTypes = {
  REPORT: 'report',
  FOLDER: 'folder',
};
